export enum RequestTableTypes {
	Pending = 'pending',
	Closed = 'closed',
	Archive = 'archive',
}